var MCB_menu = {
  menu: null,
  breakpoint: 720,
  menusize: 'S',
  init: function(){
    var self = this;
    // get the menu
    self.menu = document.querySelectorAll('header .menu')[0];

    // set now and on window resize
    self.setMenu();
    window.onresize = function() {
      if(this.resizeTO) clearTimeout(this.resizeTO);
      this.resizeTO = setTimeout(function() {
        self.setMenu();
      }, 500);
    };
  },
  setMenu: function(){
    this.menusize = this.checkViewport();
    if(this.menusize.toUpperCase() === 'S') {
      // only change the menu if it hasn't been changed yet
      if(!MCB_helpers.hasClass('menu-small', this.menu)) {
        this.makeMenuSmall();
      }
    } else {
      // only change the menu if it hasn't been changed yet
      if(!MCB_helpers.hasClass('menu-large', this.menu)) {
        this.makeMenuLarge();
      }
    }
//    console.log(this.menu);
  },
  makeMenuSmall: function(){
    var menu = this.menu;

    // set proper menu class
    MCB_helpers.removeClass('menu-large', menu);
    MCB_helpers.addClass('menu-small', menu);

    // make trigger
    var trigger = document.createElement('a');
    trigger.textContent = 'menu';
    MCB_helpers.addClass('menu-trigger', trigger);
    // set on click handler
    trigger.addEventListener('click',function(){
      console.log(menu);
      if(MCB_helpers.hasClass('menu-open', menu)) {
        console.log('closing menu');
        MCB_helpers.removeClass('menu-open', menu);  
      } else {
        console.log('opening menu');
        MCB_helpers.addClass('menu-open', menu);
      }
    })
    // prepend trigger
    menu.insertBefore(trigger, menu.firstChild);

    // change order & wrap menu's in div
    var wrapper = document.createElement('div');
    MCB_helpers.addClass('menu-wrapper', wrapper);
    var mm = menu.getElementsByClassName('menu-main')[0];
    var ml = menu.getElementsByClassName('menu-lang')[0];
    var msl = menu.getElementsByClassName('menu-site-link')[0];
    if(mm) wrapper.appendChild(mm);
    if(ml) wrapper.appendChild(ml);
    if(msl) wrapper.appendChild(msl);
    menu.appendChild(wrapper);

  },
  makeMenuLarge: function(){
    var menu = this.menu;

    // remove trigger if there is one
    var trigger = menu.getElementsByClassName('menu-trigger')[0];
    if(trigger) trigger.parentNode.removeChild(trigger);
    // revert menu to original order
    var wrapper = menu.getElementsByClassName('menu-wrapper')[0];
    if(wrapper) {
      var mm = menu.getElementsByClassName('menu-main')[0];
      var ml = menu.getElementsByClassName('menu-lang')[0];
      var msl = menu.getElementsByClassName('menu-site-link')[0];
      if(msl) menu.appendChild(msl);
      if(mm) menu.appendChild(mm);
      if(ml) menu.appendChild(ml);
      // removeWrapper
      menu.removeChild(wrapper);
    }

    // remove small-class
    MCB_helpers.removeClass('menu-small', menu);
    // set proper menu class    
    MCB_helpers.addClass('menu-large', menu);

  },
  checkViewport: function(){
    var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return w < this.breakpoint ? 'S' : 'L';
  }
}

// Cookie
var MCB_cookie = {
  init: function(){
    var self = this;
    var links = document.querySelectorAll('.menu-lang a');
    for(var i = 0; i < links.length; i++) {
      var link = links[i];
      link.addEventListener('click', function(){
        var lang = this.getAttribute('data-lang');
        if(lang !== 'none') self.createCookie('Language', lang);
      });
    }
  },
  createCookie: function(name,value) {
    // set for 100 days
    var date = new Date();
    date.setTime(date.getTime() + (100*24*60*60*1000));
    var expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + value + expires + "; path=/";
  }
}

// Helpers
var MCB_helpers = {
  hasClass: function(className, el) {
    var hasClass;
    if (el.classList) {
      hasClass = el.classList.contains(className);
    } else {
      hasClass = new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
    }
    return hasClass;
  },
  addClass: function(className, el) {
    if (el.classList) {
      el.classList.add(className);
    } else {
      el.className += ' ' + className;
    }
  },
  removeClass: function(className, el) {
    if (el.classList) {
      el.classList.remove(className);
    } else {
      el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
  },
  returnTouchClass: function(){
    var touchclass = 'no-touch';
    if('ontouchstart' in window || !!navigator.maxTouchPoints) {
      touchclass = 'touch';
    }
    return touchclass;
  }
}

// Init callback
var MCB_init = function(){
  var html = document.getElementsByTagName('html')[0];
  MCB_helpers.addClass(MCB_helpers.returnTouchClass(), html);
  MCB_menu.init();
  MCB_cookie.init();
}

// Init
if (document.readyState != 'loading'){
  MCB_init();
} else {
  document.addEventListener('DOMContentLoaded', MCB_init);
}
